// client-overview translations (English catalog).
window.PlummeI18n.register('en', {
  'kov.chip.search': 'Search: {query}',
  'kov.chip.vatLiable': 'VAT-registered: {value}',
  'kov.chip.hasEmployees': 'Has employees: {value}',
  'kov.searchClient': 'Search for a client',
  'kov.responsible': 'Responsible',
  'kov.allResponsible': 'All responsible',
  'kov.status': 'Status',
  'kov.allStatuses': 'All statuses',
  'kov.onlyActionNeeded': 'Show only clients that require action',
  'kov.moreFilters': 'More filters',
  'kov.resetFilters': 'Reset filters',
  'kov.deadline': 'Deadline',
  'kov.allDeadlines': 'All deadlines',
  'kov.next7Days': 'Next 7 days',
  'kov.companyType': 'Company type',
  'kov.all': 'All',
  'kov.yes': 'Yes',
  'kov.no': 'No',
  'kov.vatLiable': 'VAT-registered',
  'kov.hasEmployees': 'Has employees',
  'kov.title': 'Client overview',
  'kov.subtitle': 'See what needs follow-up across your clients.',
  'kov.myClients': 'My clients',
  'kov.allClients': 'All clients',
  'kov.refresh': 'Refresh',
  'kov.emptyTitle': 'No clients yet',
  'kov.emptyText': 'Clients appear here as soon as they accept the engagement. Send a request from Clients under Other.',
  'kov.kpi.needsAction': 'Requires action',
  'kov.kpi.waitingForCustomer': 'Waiting for customer',
  'kov.kpi.deadline7': 'Deadline in the next 7 days',
  'kov.kpi.deadlinePassed': 'Deadline passed',
  'kov.kpi.readyForReview': 'Ready for review',
  'kov.kpi.needsActionHelp': 'Counts unique clients, not the number of alerts.',
  'kov.showing': 'Showing:',
  'kov.removeFilter': 'Remove filter',
  'kov.sortBy': 'Sort by',
  'kov.noMatchTitle': 'No clients match the filters',
  'kov.noMatchText': 'Try changing the search or reset the filters.',
});
